export const navItems = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Find Talent", href: "/find-talent" },
  { label: "Find Jobs", href: "/find-jobs" },
  { label: "Solutions", href: "/solutions" },
  { label: "Industries", href: "/industries" },
  { label: "Impact", href: "/impact" },
  { label: "Careers", href: "/careers" },
  { label: "Blog", href: "/blog" },
];

export const heroStats = [
  { value: 18, suffix: "+", label: "Years of Excellence" },
  { value: 250, suffix: "+", label: "Talent Specialists" },
  { value: 50, suffix: "+", label: "Countries Served" },
  { value: 10000, suffix: "+", label: "Successful Placements" },
];

export const audienceCards = [
  {
    id: 1,
    audience: "For Employers",
    headline: "Hire With Precision",
    copy: "Executive search, RPO, and flexible staffing solutions aligned to your growth strategy. Our management team brings 150+ man-years of HR services experience.",
    cta: "Explore Talent Solutions",
    link: "/find-talent",
  },
  {
    id: 2,
    audience: "For Candidates",
    headline: "Build a Future, Not Just a Job",
    copy: "We connect professionals with roles that match ambition, capability, and culture. We've placed candidates across 50+ countries worldwide.",
    cta: "Find Opportunities",
    link: "/find-jobs",
  },
  {
    id: 3,
    audience: "For Enterprises Scaling Fast",
    headline: "Workforce Strategy Simplified",
    copy: "Scalable hiring models, analytics-driven sourcing powered by AI & ML, and compliant workforce deployment through our proprietary A Cube platform.",
    cta: "Talk to Experts",
    link: "/solutions",
  },
];

export const services = [
  {
    title: "Executive Search",
    subtitle: "Astral Honchos",
    icon: "Search",
    description: "Identifying and placing leaders who make a significant impact — from global enterprises to early-stage startups. Specializing in CEO Search, Board Level Positions, Leadership Hiring, and Diversity & Inclusion.",
  },
  {
    title: "Contingent Search",
    subtitle: "Astral Melance",
    icon: "Users",
    description: "Connecting clients with the right candidate by deeply understanding their needs, ethos, and work culture. Leveraging our exclusive proprietary database built through mapping and industry sources.",
  },
  {
    title: "Recruitment Process Outsourcing",
    subtitle: "Astral Bespoke",
    icon: "Settings",
    description: "World-class recruitment functions for large and mid-sized companies. Our proprietary cloud-based 'A Cube' platform integrates AI and ML for comprehensive recruitment lifecycle management.",
  },
  {
    title: "Temporary Staffing",
    subtitle: "Astral Temp",
    icon: "Clock",
    description: "Enabling businesses to meet peaks in staffing needs, expand or contract workforce according to market dynamics. Flexi-staffing, temporary-to-permanent, and on-site/off-site workforce management.",
  },
  {
    title: "Payroll Management",
    subtitle: "Astral Payroll",
    icon: "BarChart3",
    description: "Cost-effective payroll outsourcing for organizations of all sizes. Web payroll software, Employee Self Service portal, compliance support, e-TDS, Form 16 generation, and 100% accuracy guaranteed.",
  },
  {
    title: "HR Consulting",
    subtitle: "Astral Consult",
    icon: "TrendingUp",
    description: "Single point HR solutions provider — Employee Referral Programs, Exit Management, HR Policies, Training, Compensation Benchmarking, Dipstick Surveys, and organizational restructuring support.",
  },
];

export const industries = [
  { name: "Technology", icon: "Monitor" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Banking & Financial Services", icon: "Landmark" },
  { name: "Healthcare", icon: "HeartPulse" },
  { name: "Logistics & Supply Chain", icon: "Truck" },
  { name: "Energy & EV", icon: "Zap" },
  { name: "Consumer & Retail", icon: "ShoppingBag" },
];

export const differentiators = [
  {
    title: "Global Reach",
    description:
      "Placements in 50+ countries across the globe. Recruitment capabilities spanning metro and rural areas pan-India with 9 offices worldwide.",
    icon: "Globe",
  },
  {
    title: "People & Expertise",
    description:
      "A 300+ member team with a leadership team bringing 150+ years of combined industry experience. Co-founded and built 3 of India's largest HR firms.",
    icon: "Users",
  },
  {
    title: "Technology Powered",
    description:
      "Proprietary cloud-based A Cube platform powered by AI & ML, with configurable dashboards for bespoke hiring solutions and trend-based searches.",
    icon: "Layers",
  },
];

export const awards = [
  {
    highlight: "Cummins",
    text: "Recipient of the prestigious \"Diversity Supplier of the Year Award\" from Cummins.",
  },
  {
    highlight: "Silicon India",
    text: "Ranked as the \"Top 5 Most Promising HR Recruitment Companies in India\" by Silicon India.",
  },
  {
    highlight: "Oxford Economics",
    text: "Featured as a \"Case Study\" in an Amex study on SME Pulse, showcasing how global SMEs are driving growth.",
  },
  {
    highlight: "Forbes",
    text: "Global outreach spotlighted by Forbes Magazine. Founders featured for their achievement in creating a global recruitment firm.",
  },
];

export const mediaLogos = [
  "Forbes",
  "Silicon India",
  "Oxford Economics",
  "Cummins",
];

export const testimonials = [
  {
    name: "Kishore Jayaraman",
    title: "President",
    company: "Rolls Royce - APAC",
    quote: "It was a pleasure working with Ad Astra. You all understood our requirements and not just met them but also coached us about current market trends. The work was done within all aggressive timelines and the right candidate slate was put in front of us to reach a conclusion very quickly.",
  },
  {
    name: "Sandeep Bhatia",
    title: "Deputy Managing Director",
    company: "Capgemini",
    quote: "Working with Ad Astra was a fantastic experience. The team's ability to understand business needs and fill each position with tight deadlines, while not compromising on the quality of candidates was amazing. They also delivered market research, diversity hiring and recruitment outsourcing at very high standards.",
  },
  {
    name: "Raja Kumar",
    title: "Founder & Managing Partner",
    company: "Ascent Capital",
    quote: "Ad Astra's team has the great ability to rise to a situation and give it their best. From conceptualizing to candidate joining, they were there with us at every step. Their expertise led us to use their services for CFO requirements of our portfolio companies.",
  },
  {
    name: "Ben Richardson",
    title: "VP Global Marketing",
    company: "Stanley Black & Decker",
    quote: "Ad Astra thoroughly understood our business challenges and requirements, providing well-matched profiles. We recruited 10 roles in just 2 months, without compromising candidate quality \u2014 a remarkably fast turnaround for marketing positions.",
  },
  {
    name: "Kyle Kumasaka",
    title: "Senior Director",
    company: "LiquidHub",
    quote: "I do not think that LiquidHub could have completed this endeavor with any other partner. Ad Astra's team was professional, diligent, intelligent and highly competent. I would be more than happy to provide a 5-star review!",
  },
  {
    name: "Raghavan G",
    title: "Managing Director",
    company: "KAER Air",
    quote: "My interactions with Ad Astra have been impressive \u2014 from a thorough understanding of needs, expansive research, and insightful commentary of options. A highly reliable partner.",
  },
  {
    name: "Orinola Gbadebo Smith",
    title: "Co-Founder & CEO",
    company: "Hugo",
    quote: "A truly exceptional experience! The breadth of their search; the speed and precision with which they delivered on a global executive that was both a competence- and culture-fit...remarkable. Five stars.",
  },
  {
    name: "D N Prasad",
    title: "President",
    company: "SHRI",
    quote: "Ad Astra is a firm that I have known for more than a decade now. They understand our Domain well since they have a professional from the Banking Finance Industry as a Co-Founder. Responsive and Committed.",
  },
];

export const footerLinks = {
  Company: ["About Us", "Leadership", "Careers", "Press"],
  Services: ["Executive Search", "Contingent Search", "RPO", "Temporary Staffing", "Payroll Management", "HR Consulting"],
  Industries: ["Technology", "Manufacturing", "Banking", "Healthcare"],
  Insights: ["Blog", "Reports", "Case Studies", "Webinars"],
};

export const offices = [
  {
    city: "Bangalore",
    tag: "Headquarters",
    company: "Ad Astra Consultants (P) Limited",
    address: "1st Floor, CRN Square, No 15, Kasturba Road, Bangalore – 560 001",
    phone: "+91-80-40700 602–635",
    fax: "+91-80-40700 629",
  },
  {
    city: "Hyderabad",
    company: "Ad Astra Consultants (P) Limited",
    address: "3rd Floor, SBR Surya Pearl Building, Phase 2, Hi-tech City, Madhapur, Hyderabad 500081",
    phone: "8008544010",
  },
  {
    city: "Kolkata",
    company: "Ad Astra Consultants (P) Limited",
    address: "DBS Corporate House, DBS House, 10-2, Hungerford Street, Kolkata – 700 017",
    phone: "+91-33-4050 9200",
    fax: "+91-33-4050 9300",
  },
  {
    city: "Mumbai",
    company: "Ad Astra Consultants (P) Limited",
    address: "501, 5th Floor, Meadows, Sahar Plaza, Chakala Metro Station, Andheri (East), Mumbai – 400 059",
    phone: "+91-22-4012 0290",
  },
  {
    city: "New Delhi",
    company: "Ad Astra Consultants (P) Limited",
    address: "1301, 13th Floor, Surya Kiran Building, #19, Kasturba Gandhi Marg, New Delhi – 110 001",
    phone: "+91-11-4763 4800 / 4763 4900",
    fax: "+91-11-4763 4837",
  },
  {
    city: "Coimbatore",
    company: "Ad Astra Consultants (P) Limited",
    address: "Mobax Networks, 2nd Floor, Vivekananda Rd, Ram Nagar, Coimbatore, Tamil Nadu 641009",
  },
  {
    city: "Singapore",
    company: "Ad Astra Consultants Pte. Ltd.",
    address: "105 Cecil Street, The Octagon, #13-01, Singapore – 069534",
  },
  {
    city: "London",
    company: "Ad Astra Consultants Pvt. Ltd.",
    address: "Ground Floor, Suite B, 4 Lytton Road, New Barnet, Hertfordshire EN55BY",
  },
  {
    city: "Amsterdam",
    company: "Ad Astra Consultants B.V.",
    address: "Herengracht 449 A, 1017BR Amsterdam",
  },
];

export const contactInfo = {
  email: "info@adastraconsultants.com",
  headquarters: "Bangalore, India",
};
